// Origins of the Weavy environment on this page: the UI kit is always loaded
// from it (<script src="https://<env>.weavy.io/uikit-web/weavy.js">), so its
// script tag names the origin without the component needing configuration.
function weavyOrigins(doc) {
  const out = new Set();
  for (const s of doc?.querySelectorAll?.('script[src*="/uikit-web/"]') || []) {
    try { out.add(new URL(s.src, doc.location?.href).origin); } catch { /* not a URL */ }
  }
  return out;
}

// A link into Weavy is Weavy's to handle. Attached files, image previews and
// other surfaces open in Weavy's own viewer from the same click; taking the
// click over sent the user to a raw file URL in a new tab instead. Exempt the
// environment the UI kit came from, and any *.weavy.io host it serves files
// from.
export function isWeavyUrl(url, doc = globalThis.document) {
  return weavyOrigins(doc).has(url.origin) || /(^|\.)weavy\.io$/i.test(url.hostname);
}

// Shadow DOM retargets event.target; composedPath preserves message anchors.
export function openExternalChatLink(event, host) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
  const path = event.composedPath?.() || [];
  if (!path.includes(host)) return false;
  const anchor = path.find(node => node?.tagName === 'A' && node.href);
  if (!anchor || anchor.hasAttribute?.('download')) return false;
  let url;
  try { url = new URL(anchor.href, window.location.href); } catch { return false; }
  if (!['http:', 'https:'].includes(url.protocol) || url.origin === window.location.origin) return false;
  if (isWeavyUrl(url)) return false;
  event.preventDefault();
  event.stopPropagation();
  window.open(url.href, '_blank', 'noopener,noreferrer');
  return true;
}
